//cart
export const cartGetters = {
    //return cart
    cartProducts: state => {
        return state.added.map(({ id, quantity }) => {
            const product_item = state.all.find(p => p._id === id)
        
            return {
                name: product.name,
                price: product.price,
                quantity
            }
        })
    }
}
   


// WEBPACK FOOTER //
// ./src/store/getters.js